import React, { useEffect, useState } from 'react';
import TauriDatePickerCoverage from './TauriDatePickerCoverage/TauriDatePickerCoverage';
import TauriSidebarFilter from './TauriSidebarFilter/TauriSidebarFilter';
import OpalAccordionItem from '../../OpalAccordionItem/OpalAccordionItem';
import TauriLoader2 from '../../TauriLoader2/TauriLoader2';
import './CoverageSidebar.css';
import { getAll, getRecordById } from '../../../localDB';
import TauriImage from '../../TauriImage/TauriImage';
import { Button } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import config from '../../../config.json';
import appURL from '../../../appURL.json';
import { insertDefaultAccount, insertIncidentalNotExist, transformEventData, transformSessionData, updateLocal, updateLocalSessionJoint } from '../CoverageFactoryData/CoverageFactoryData';
import { SessionTag, sessionType, statusMapping, SyncStatusMap } from '../../../visualizations/visualizations';
import { useBaseProvider } from '../../../BaseManager/BaseManager';

const getTodayWithTimezoneOffset = () => {
    const now = new Date();
    now.setHours(0, 0, 0, 0); // Ensuring time does not affect date selection
    return now;
};

const CoverageSidebar = ({ onSelectItem, selectedItem, selectedDate, setSelectedDate, loading, setLoading, isMD }) => {

    const [itemList, setItemList] = useState([]);
    const [isJoint, setIsJoint] = useState(false);
    const [cyclePeriod, setCyclePeriod] = useState('')
    const [cycle, setCycle] = useState([]);
    const [selectedFilter, setSelectedFilter] = useState(null);

    const [selectedCard, setSelectedCard] = useState(null);

    const { coverageSearch, setCoverageSearch, isSidebarCollapsed, setIsSidebarCollapsed, signalRConnection } = useBaseProvider();

    const navigate = useNavigate();
    const { id } = useParams();

    useEffect(() => {
        if (selectedItem) {
            setSelectedCard(Number(selectedItem));
        }
    }, [selectedItem]);

    useEffect(() => {
        if (!signalRConnection) return;

        const handleSessionStartSignalR = async (s) => {
            if (!s) return;

            const sessionID = Number(s.sessionID);
            const ActualStart = s.timestamp
                ? new Date(s.timestamp).toISOString()
                : new Date().toISOString();

            const Type = sessionType[s.type] ?? sessionType.Regular;

            localStorage.setItem("preventNavigation", true);
            setItemList(prevList => {
                const updatedList = prevList.map(item =>
                    item.ID === sessionID
                        ? {
                            ...item,
                            ActualStart,
                            Type,
                            Status: statusMapping.inprogress,
                        }
                        : item
                );

                return updatedList;
            });
        }

        const handleSessionEndSignalR = async (s) => {
            if (!s) return;

            const sessionID = Number(s.sessionID);
            const session = await getRecordById("session", sessionID);
            if (!session) return;

            const ActualEnd = s.timestamp
                ? new Date(s.timestamp).toISOString()
                : new Date().toISOString();


            let newStatus;
            if (session.Type === sessionType.Recovery) {
                newStatus = session.Joint
                    ? statusMapping.recoveredjointcall
                    : statusMapping.recovered;
            } else if (session.Type === sessionType.Advanced) {
                newStatus = session.Joint
                    ? statusMapping.advancedjointcall
                    : statusMapping.advanced;
            } else {
                newStatus = session.Joint
                    ? statusMapping.successjointcall
                    : statusMapping.success;
            }

            localStorage.setItem("preventNavigation", true);
            if (s) {
                setItemList(prevList =>
                    prevList.map(item =>
                        item.ID === sessionID ?
                            {
                                ...item,
                                ActualEnd: ActualEnd,
                                Status: newStatus,
                            } : item
                    )
                );
            }
        }

        const handleSessionMarkAsJointCallSignalR = async (sessionIds) => {
            if (!Array.isArray(sessionIds) || sessionIds.length === 0) return;

            localStorage.setItem("preventNavigation", true);

            setItemList(prevList => {
                let updatedList = [...prevList];

                sessionIds.forEach(idValue => {
                    const sessionID = Number(idValue);

                    updatedList = updatedList.map(item => {
                        if (item.ID !== sessionID) return item;

                        // Compute new status based on Type + Joint=true
                        let newStatus;

                        if (item.Type === sessionType.Recovery) {
                            newStatus = statusMapping.recoveredjointcall;
                        } else if (item.Type === sessionType.Advanced) {
                            newStatus = statusMapping.advancedjointcall;
                        } else {
                            newStatus = statusMapping.successjointcall;
                        }

                        return {
                            ...item,
                            Joint: true,
                            Status: newStatus
                        };
                    });
                });

                return updatedList;
            });
        };

        signalRConnection.on("SessionStarted", handleSessionStartSignalR);
        signalRConnection.on("SessionEnded", handleSessionEndSignalR);
        signalRConnection.on("MarkAsJointCall", handleSessionMarkAsJointCallSignalR);

        return () => {
            signalRConnection.off("SessionStarted", handleSessionStartSignalR);
            signalRConnection.off("SessionEnded", handleSessionEndSignalR);
            signalRConnection.off("MarkAsJointCall", handleSessionMarkAsJointCallSignalR);
        };
    }, [signalRConnection, id])

    const fetchDataCyclePeriod = async () => {

        try {
            const cycleList = await getAll("Cycle");
            setCycle(cycleList);

        } catch (error) {
            console.log('error fetching..');
        }
    }

    const fetchSessionsData = async () => {
        try {
            setLoading(true);
            const isOnline = JSON.parse(localStorage.getItem("isOnline"));
            const hasInternet = navigator.onLine;

            if (isOnline && hasInternet) {
                await fetchSession(); // From server
            } else {
                await fetchData(coverageSearch, selectedDate); // From local DB
            }
        } catch (error) {
            console.error("Failed to fetch session data:", error);
            await fetchData(coverageSearch, selectedDate);
        } finally {
            setLoading(false);
        }
    };

    const fetchData = async (search, date) => {
        try {
            const coverageList = await getAll("session");
            const sessionJoint = await getRecordById("SessionJointDays", selectedDate.toLocaleDateString("en-CA"));
            const sessions = coverageList.filter(a =>
                a.SyncStatus !== SyncStatusMap.done &&
                (selectedFilter?.show || ![1, 4, 8, 9].includes(a.Status))
            );

            const customerList = await getAll("customer");
            const institutionList = await getAll("institution");
            const filteredCoverageList = sessions.filter(
                item =>
                    (item.Tag == null || item.Tag === SessionTag.incidental) &&
                    new Date(item.SessionDate).toDateString() === new Date(selectedDate).toDateString()
            );

            const data = filteredCoverageList.map(session => {
                const customer = customerList.find(c => c.ID === session.AccountID);
                if (!customer) return { ...session, Customer: null };

                const inst = institutionList.find(c => c.ID === customer.InstitutionID);

                return {
                    ...session,
                    Customer: {
                        ...customer,
                        InstitutionName: inst?.Name || null
                    }
                };
            });

            const lowercasedValue = search.toLowerCase();

            const filtered = data
                .filter((item) =>
                    item?.Customer?.Name?.toLowerCase().includes(lowercasedValue) ||
                    item?.Customer?.AddressDetail?.toLowerCase().includes(lowercasedValue)
                )
                .sort((a, b) => {
                    const key = selectedFilter?.orderby;
                    const aVal = a.Customer?.[key] || '';
                    const bVal = b.Customer?.[key] || '';
                    return aVal.localeCompare(bVal);
                });

            setItemList(filtered);
            setIsJoint(sessionJoint.joint || false);

        } catch (error) {
            console.log(error);
        }
    }

    const fetchSession = async () => {
        try {
            const lowercasedValue = coverageSearch.toLowerCase();
            const token = localStorage.getItem('token');
            const devId = localStorage.getItem('devId');
            const userGroupIDs = localStorage.getItem('usr_g');

            const response = await fetch(`${appURL.API_Session}?d=${selectedDate.toLocaleDateString('en-CA')}&g=${userGroupIDs}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                    'X-ETR-DeviceID': devId
                },
            });

            if (!response.ok) {
                console.error('Failed to fetch session!');
                return;
            }

            const data = await response.json();

            await updateLocal(data.sessions, selectedDate.toLocaleDateString('en-CA'), data?.cycle?.id);
            await updateLocal(data.events, selectedDate.toLocaleDateString('en-CA'), data?.cycle?.id);
            await updateLocalSessionJoint(selectedDate.toLocaleDateString('en-CA'), data.joint);
            await insertDefaultAccount(data.sessions);
            await insertIncidentalNotExist(data.sessions, selectedDate.toLocaleDateString('en-CA'), data?.cycle?.id);

            const interpretData = await transformSessionData(data.sessions, selectedDate.toLocaleDateString('en-CA'), data?.cycle?.id);

            const interpretEventData = await transformEventData(data.events, selectedDate.toLocaleDateString('en-CA'), data?.cycle?.id);

            const merged = [...interpretData, ...interpretEventData];

            const filtered = merged
                .filter(a =>
                    (selectedFilter?.show || ![1, 4, 8, 9].includes(a.Status)) &&
                    (
                        a.Customer?.Name?.toLowerCase().includes(lowercasedValue) ||
                        a.Customer?.AddressDetail?.toLowerCase().includes(lowercasedValue) ||
                        a.Activity?.Description?.toLowerCase().includes(lowercasedValue) // events
                    )
                )
                .sort((a, b) => {
                    const key = selectedFilter?.orderby;
                    const aVal = a.Customer?.[key] || '';
                    const bVal = b.Customer?.[key] || '';
                    return aVal.localeCompare(bVal);
                });

            setItemList(filtered);
            setIsJoint(data.joint);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchDataCyclePeriod();
    }, []);

    useEffect(() => {
        if (!cycle || cycle.length === 0) return;

        const today = getTodayWithTimezoneOffset();
        handleSetCycle(today?.toLocaleDateString('en-CA'));
    }, [cycle])

    useEffect(() => {
        const handleSessionChange = () => {
            fetchSessionsData();
        };

        const handleDateChange = () => {
            const storedDate = localStorage.getItem("dateSelect");
            setSelectedDate(new Date(JSON.parse(storedDate)));
        };

        fetchSessionsData();

        window.addEventListener("session", handleSessionChange);
        window.addEventListener("dateSelect", handleDateChange);

        return () => {
            window.removeEventListener("session", handleSessionChange);
            window.removeEventListener("dateSelect", handleDateChange);
        };
    }, [coverageSearch, selectedDate, selectedFilter]);

    useEffect(() => {
        if (itemList.length > 0) {
            const preventNavigation = JSON.parse(localStorage.getItem("preventNavigation"));

            const storedDate = localStorage.getItem("dateSelect");
            if (storedDate) {
                localStorage.removeItem("dateSelect");
                return
            }

            // Only proceed with navigation if preventNavigation is not set or is false
            if (preventNavigation !== true) {
                onSelectItem(itemList[0]);
                const targetID = itemList[0].ID;
                navigate(`/coverage/${targetID}`);
            }

            localStorage.removeItem("preventNavigation");
        } else {
            navigate("/coverage");
        }
    }, [itemList]);

    useEffect(() => {
        const date = new Date(selectedDate);
        handleSetCycle(date?.toLocaleDateString('en-CA'));
    }, [selectedDate])

    const handleSetCycle = (value) => {

        if (!value) return;
        const date = new Date(value);

        const foundCycle = cycle.find(c => {
            const start = new Date(c.StartDate);
            const end = new Date(c.EndDate);

            return date >= start && date <= end;
        });

        setCyclePeriod(foundCycle);
    }

    const handleSearch = (value) => {
        setCoverageSearch(value);
    };

    const handleSelectItem = (item) => {
        onSelectItem(item);
    };

    return (
        <div className='coverage-sidebar' style={{ display: isSidebarCollapsed & !isMD ? 'none' : 'block' }}>
            <Button className="btn-sidebar-minimize d-none d-md-block" onClick={() => setIsSidebarCollapsed(true)}>
                <TauriImage
                    localImage="/Images/solar--double-alt-arrow-left-outline.svg"
                    alt="icon"
                    color="#1D5D9B"
                />
            </Button>

            {isJoint &&
                <TauriImage
                    localImage="/Images/mdi--handshake-outline.svg"
                    alt="icon"
                    className={"img-jointcall d-none d-md-block me-1 mt-1"}
                />
            }

            <TauriDatePickerCoverage
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                cyclePeriod={cyclePeriod}
            />
            <TauriSidebarFilter
                searchTerm={coverageSearch}
                setSearchTerm={setCoverageSearch}
                setSelectedDate={setSelectedDate}
                setSelectedFilter={setSelectedFilter}
                setIsSidebarCollapsed={setIsSidebarCollapsed}
            />

            {loading ? (
                <TauriLoader2 width="2.5rem" height="2.5rem" borderwidth="0.35rem" color="#1D5D9B" />
            ) : (
                <OpalAccordionItem
                    items={itemList}
                    search={coverageSearch}
                    onSelectItem={handleSelectItem}
                    showHeader={selectedFilter?.groupby}
                    type={"v1"}
                    selectedCard={selectedCard}
                    setSelectedCard={setSelectedCard}
                    groupby={selectedFilter?.groupby}
                />
            )}
        </div>
    );
};

export default CoverageSidebar;
